import { createContext } from 'react';

import type { DraggableSyntheticListeners } from '@dnd-kit/core';

/** Set by the sortable panel so a widget header acts as the drag handle. */
export type WidgetDragValue = {
  setActivatorNodeRef?: (el: HTMLElement | null) => void;
  listeners?: DraggableSyntheticListeners;
};

export const WidgetDragContext = createContext<WidgetDragValue | null>(null);
